module.exports = __webpack_public_path__ + "img/choose_chapter_small.43de3a67.png";